var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Alert',{staticClass:"draft-alert",attrs:{"theme":"primary","iconPlacement":"left","icon":['fas', 'info-circle']}},[_c('div',{staticClass:"draft-alert__content",domProps:{"innerHTML":_vm._s(_vm.content || _vm.$t('workingWithDraft'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }